module.exports = __webpack_public_path__ + "static/media/texture (26).acb3e7ed.jpg";